module.exports = __webpack_public_path__ + "c9d8727d52a30ebe8ca2b27dbc93a9c4.jpg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/bg.jpg
 ** module id = 170
 ** module chunks = 0
 **/